
export function getTimeoutSettings(){
    let timeoutSettings;
    const customerJson = `assets/config/customer.json`;
    let request = new XMLHttpRequest();
    request.open('GET', customerJson, false);
    request.send(null);
    try {
        const response = JSON.parse(request.responseText);
        timeoutSettings = response.settings.timeout;
        //if any of the values are missing or empty use default values
        if(timeoutSettings.idle == null || (timeoutSettings.idle != null && timeoutSettings.idle === '')){
            timeoutSettings.idle = 540;
        }
        if(timeoutSettings.timeout == null || (timeoutSettings.timeout != null && timeoutSettings.timeout === '')){
            timeoutSettings.timeout = 30;
        }
        if(timeoutSettings.ping == null || (timeoutSettings.ping != null && timeoutSettings.ping === '')){
            timeoutSettings.ping = 240;
        }
    } catch (e) {
        //if there is a parsing error use default values
        timeoutSettings = {
            idle: 540,
            timeout: 30,
            ping: 240
        }
    }
    return timeoutSettings;
}